import { Box, Divider, Typography } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { WidgetContext } from "src/contexts/WidgetContext";
import { useContext, type MouseEvent } from "react";
import { isNativeAppReviewSupported } from "src/services/appReview";

interface HelpMenuMainProps {
  onChangeContent: (content: string) => void;
  /** When provided, "Feedback" menu item opens the RotoGPT feedback popup instead of changing view */
  onFeedbackClick?: () => void;
  /** iOS/Android native: in-app / store review prompt */
  onRateAppClick?: () => void;
}

export const HelpMenuMain = ({ onChangeContent, onFeedbackClick, onRateAppClick }: HelpMenuMainProps) => {
  const { isLoggedInAuth0ExperienceGlobal } = useContext(WidgetContext);
  const allMenuItems = [
    { id: "contactUs", label: "Contact Us" },
    { id: "gettingStarted", label: "Getting Started" },
    { id: "faq", label: "FAQ" },
    { id: "glossary", label: "Glossary" },
    { id: "whatsNew", label: "What's New" },
    { id: "reportBug", label: "Report a Bug" },
    { id: "suggestFeature", label: "Suggest a Feature" },
    { id: "feedback", label: "Feedback" },
    // ...(isNativeAppReviewSupported() ? [{ id: "rateApp", label: "Rate the App" }] : []),
    { id: "readTermsAndConditions", label: "Terms and Conditions" },
  ];

  // Filter out "Getting Started" if user is not logged in
  const menuItems = allMenuItems.filter(
    (item) => !(isLoggedInAuth0ExperienceGlobal && item.id === "gettingStarted")
  );

  const seoHrefForItem = (id: string): string | undefined => {
    if (id === "faq") return "/faq";
    if (id === "glossary") return "/glossary";
    return undefined;
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{
        p: 2,
      }}
      gap={0}
    >
      {menuItems.map((item, index) => (
        <Box key={item.id} sx={{ width: "100%" }}>
          <Box
            component={seoHrefForItem(item.id) ? "a" : "div"}
            href={seoHrefForItem(item.id)}
            onClick={(e: MouseEvent) => {
              if (seoHrefForItem(item.id)) {
                e.preventDefault();
              }
              if (item.id === "feedback" && onFeedbackClick) {
                onFeedbackClick();
              } else if (item.id === "rateApp" && onRateAppClick) {
                onRateAppClick();
              } else {
                onChangeContent(item.id);
              }
            }}
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{
              cursor: "pointer",
              py: 1.5,
              px: 1,
              width: "100%",
              textDecoration: "none",
              color: "inherit",
            }}
          >
            <Typography
              variant="h6"
              color={`${PureLightThemeCaaS.colors.alpha.black[100]}`}
              textAlign="left"
              sx={{
                fontSize: "15px",
                fontWeight: "medium",
              }}
            >
              {item.label}
            </Typography>
            <ChevronRightIcon
              sx={{
                color: `${PureLightThemeCaaS.colors.alpha.black[100]}`,
                fontSize: "24px",
              }}
            />
          </Box>
          {index < menuItems.length - 1 && (
            <Divider
              sx={{
                // margin: {
                //   xs: "auto",
                //   md: "0px",
                // },
                width: "98%",
                height: "1.5px",
                bgcolor: `${PureLightThemeCaaS.colors.alpha.black[30]}`,
                // py:0.1,
                my: 0,
                mx: "auto",
                // m: "0 auto",
              }}
            />
          )}
        </Box>
      ))}
    </Box>
  );
};
